import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
} from "react-router-dom";

import Layout from "./pages/layout";
import Login from "./pages/login";
import HomeIn from "./pages/homeIn";
import SolicitarRedefinirSenha from "./pages/solicitarRedefinirSenha";
import RedefinirSenha from "./pages/redefinirSenha";
import { Socket } from "socket.io-client";
import { Dispatch, SetStateAction, memo } from "react";
import TemplatePage from "./pages/template";
import Cadastro from "./pages/cadastro";
import LayoutPublic from "./pages/layoutPublic";
import Load from "./pages/loadRedirect";

import checkAuthenticated from "./pages/protectedRoute/loaderFunction";
import { usePages } from "./context/pageContext";
import Configuracoes from "./pages/gerenciamento";
import Administracao from "./pages/gerenciamento/administracao";
import Telas from "./pages/gerenciamento/telas";
import { TemplateProvider } from "./context/templateContext";
import { VerifyPermission } from "./utils/verifyPermission";
import WelcomePage from "./pages/welcome";
import FiltersConfig from "./pages/gerenciamento/filters";
import AddFilter from "./pages/gerenciamento/filters/addFilter";
import EditFilter from "./pages/gerenciamento/filters/editFilter/intex";
import DataSource from "./pages/gerenciamento/dataSource";
import FormularioDataSource from "./pages/gerenciamento/dataSource/formDataSource";

interface RoutersProps {
  socket: Socket;
  setCheckLogin: Dispatch<SetStateAction<boolean>>;
  checkLogin: boolean;
  setColorMode: Dispatch<SetStateAction<boolean>>;
  colorMode: boolean;
}

const AppRouter = ({ socket, setColorMode, colorMode }: RoutersProps) => {
  const { setCheckLogin, pages } = usePages();

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/dashboard" />} />

        <Route element={<LayoutPublic />}>
          <Route path="/resetPassword" element={<SolicitarRedefinirSenha />} />
          <Route
            path="/resetPassword/:token/:id"
            element={<RedefinirSenha />}
          />
          <Route path="/cadastro" element={<Cadastro />} />
        </Route>

        <Route
          loader={() => checkAuthenticated(setCheckLogin)}
          shouldRevalidate={({ currentUrl, nextUrl }) =>
            currentUrl.pathname !== nextUrl.pathname
          }
        >
          <Route path="/loadRedirect" element={<Load />} />
          <Route
            element={
              <TemplateProvider>
                <Layout
                  socket={socket}
                  colorMode={colorMode}
                  setColorMode={setColorMode}
                />
              </TemplateProvider>
            }
          >
            <Route path="homeIn" element={<HomeIn />} />
            <Route
              path="configuracoes"
              element={
                <VerifyPermission>
                  <Navigate replace to="/configuracoes/administracao" />
                </VerifyPermission>
              }
            />
            <Route
              element={
                <VerifyPermission>
                  <Configuracoes />
                </VerifyPermission>
              }
            >
              <Route
                path="/configuracoes/administracao"
                element={<Administracao />}
              />
              <Route
                path="/configuracoes/paginas"
                element={<Telas socket={socket} />}
              />
              <Route
                path="/configuracoes/filtros/:pageId?"
                element={<FiltersConfig socket={socket} />}
              />
              <Route
                path="configuracoes/filters/add/:pageId"
                element={<AddFilter />}
              />
              <Route
                path="configuracoes/filters/edit/:pageId/:variableName"
                element={<EditFilter />}
              />
              <Route path="configuracoes/datasource" element={<DataSource />} />
              <Route
                path="configuracoes/datasource/criar"
                element={<FormularioDataSource />}
              />
              <Route
                path="configuracoes/datasource/editar/:id"
                element={<FormularioDataSource />}
              />
            </Route>
            <Route
              path="dashboard/:page?/:card?"
              element={
                !Array.isArray(pages) || pages.length === 0 ? (
                  <WelcomePage />
                ) : (
                  <TemplatePage />
                )
              }
            />
          </Route>
        </Route>
      </Route>,
    ),
  );

  return <RouterProvider router={router} />;
};

export default memo(AppRouter);
